import { Navigate, useLocation, useNavigate } from "react-router-dom";
import type { AccountRow } from "../params/types";
import MigrationDownloader from "./MigrationDownloader";
import MigrationRemover from "./MigrationRemover";
import MigrationUsername from "./MigrationUsername";
import MigrationUploader from "./MigrationUploader";

const TABS = [
  { id: "downloader", label: "Downloader" },
  { id: "uploader", label: "Uploader" },
  { id: "remover", label: "Remover" },
  { id: "username", label: "Username" },
] as const;

interface MigrationProps {
  accounts?: AccountRow[];
  setError?: (message: string) => void;
}

export default function Migration({ accounts, setError }: MigrationProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const tab = TABS.find((t) => pathname.split("/").includes(t.id))?.id;

  // /migration (or an unknown sub-path) lands on the downloader.
  if (!tab) return <Navigate to="/migration/downloader" replace />;

  return (
    <div className="ib-migration-view">
      <div className="ib-subtabs" role="tablist">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={tab === t.id}
            className={`ib-subtab${tab === t.id ? " ib-subtab--active" : ""}`}
            onClick={() => navigate(`/migration/${t.id}`)}
          >
            {t.label}
          </button>
        ))}
      </div>
      {/* Both stay mounted so a finished download isn't lost on tab switch. */}
      <div hidden={tab !== "downloader"}>
        <MigrationDownloader accounts={accounts} setError={setError} />
      </div>
      <div hidden={tab !== "uploader"}>
        <MigrationUploader
          accounts={accounts}
          active={tab === "uploader"}
          setError={setError}
        />
      </div>
      <div hidden={tab !== "remover"}>
        <MigrationRemover accounts={accounts} setError={setError} />
      </div>
      <div hidden={tab !== "username"}>
        <MigrationUsername accounts={accounts} setError={setError} />
      </div>
    </div>
  );
}
